import React, { Fragment, useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./style.css";

import { logout } from "./Action";
import { LayoutContext } from "../index";
import { isAdmin } from "../auth/fetchApi";
import { useCart } from "../../../contexts/CartContext";

const Navber = (props) => {
  const history = useHistory();
  const location = useLocation();

  const { data, dispatch } = useContext(LayoutContext);
  const { getCartCount } = useCart();

  // removed unused helper to satisfy eslint no-unused-vars

  const navberToggleOpen = () =>
    data.navberHamburger
      ? dispatch({ type: "hamburgerToggle", payload: false })
      : dispatch({ type: "hamburgerToggle", payload: true });

  const closeMenu = () => {
    if (data.navberHamburger) {
      dispatch({ type: "hamburgerToggle", payload: false });
    }
  };

  const loginModalOpen = () =>
    data.loginSignupModal
      ? dispatch({ type: "loginSignupModalToggle", payload: false })
      : dispatch({ type: "loginSignupModalToggle", payload: true });

  const cartModalOpen = () =>
    data.cartModal
      ? dispatch({ type: "cartModalToggle", payload: false })
      : dispatch({ type: "cartModalToggle", payload: true });

  // Fermer le menu au scroll
  useEffect(() => {
    const handleScroll = () => {
      if (data.navberHamburger) {
        closeMenu();
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [data.navberHamburger]);

  return (
    <Fragment>
      {/* Navber Section */}
  <nav className="sticky top-0 w-full z-20 shadow-lg lg:shadow-none bg-blue-100">
        <div className="m-4 md:mx-12 md:my-6 grid grid-cols-4 lg:grid-cols-3">
          <div className="hidden lg:block col-span-1 mt-4 flex text-blue-800 mt-1">
              <a
                href="/"
                className="hover:bg-yellow-700 px-4 py-3 rounded-lg font-light tracking-widest hover:text-white cursor-pointer"
              >
                Accueil
              </a>

              <a
              href="/#shop"
              className="hover:bg-yellow-700 px-4 py-3 rounded-lg font-light tracking-widest hover:text-white cursor-pointer"
            >
              Produits
            </a>
                
                {/* <a
              href="/#aboutus"
              className="hover:bg-gray-200 px-4 py-3 rounded-lg font-light tracking-widest hover:text-gray-800 cursor-pointer"
            >
              À propos
            </a>       */}
          
            <span
              className="hover:bg-yellow-700 px-4 py-3 rounded-lg font-light tracking-widest hover:text-white cursor-pointer"
              onClick={() => {
                history.push("/contact-us")
              }}
            >
              Contacts
            </span>
          </div>
          <div className="col-span-2 lg:hidden flex items-center">
            <button
              onClick={(e) => navberToggleOpen()}
              className="p-2 rounded-xl bg-yellow-700 shadow-lg hover:shadow-xl hover:bg-yellow-600 transition-all duration-300 mr-3 group"
              aria-label={data.navberHamburger ? "Fermer le menu" : "Ouvrir le menu"}
            >
              <div className="relative w-6 h-6 flex items-center justify-center">
                {data.navberHamburger ? (
                  /* Icône X moderne */
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                ) : (
                  /* Icône menu moderne */
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                )}
              </div>
            </button>
            <img
              onClick={() => history.push("/")}
              src="/images/logo1.png" 
              alt="Jamaal Store Logo"
              className="h-8 cursor-pointer"
            />
            
          </div>
          <div
  onClick={() => history.push("/")}
  className="hidden lg:flex justify-center items-center col-span-1 cursor-pointer"
          >
            <img
              src="/images/logo1.png"
              alt="Jamaal Store Logo"
              className="h-10 object-contain"
            />
          </div>

          <div className="flex items-right col-span-2 lg:col-span-1 flex justify-end">
            {/*  WishList Page Button */}
            <div
              onClick={(e) =>  history.push("/wish-list")}
              className="hover:bg-yellow-50 rounded-xl px-2 py-2 cursor-pointer transition-all duration-200 group"
              title="Wishlist"
            >
              <svg
                className={`${
                  location.pathname === "/wish-list"
                    ? "fill-current text-yellow-600"
                    : "text-blue-800"
                } w-8 h-8 cursor-pointer group-hover:text-yellow-600 transition-colors`}
                fill={location.pathname === "/wish-list" ? "currentColor" : "none"}
                stroke="currentColor"
                strokeWidth={location.pathname === "/wish-list" ? 0 : 2}
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
                />
              </svg>
            </div>
            {localStorage.getItem("jwt") ? (
              <Fragment>
                <div
                  className="userDropdownBtn hover:bg-yellow-50 px-2 py-2 rounded-xl relative transition-all duration-200 group"
                  title="Mon compte"
                >
                  <svg
                    className="cursor-pointer w-8 h-8 text-blue-800 group-hover:text-yellow-600 transition-colors"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path fillRule="evenodd" d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" clipRule="evenodd" />
                  </svg>
                  <div className="userDropdown absolute right-0 mt-1 bg-white rounded-lg shadow-xl border border-gray-100 overflow-hidden">
                    {!isAdmin() ? (
                      <Fragment>
                        <li className="flex flex-col text-gray-700 w-64">
                          <span
                            onClick={(e) =>  history.push("/user/profile")}
                            className="flex items-center space-x-3 py-3 px-6 hover:bg-yellow-50 cursor-pointer transition-colors"
                          >
                            <svg
                              className="w-5 h-5 text-blue-600"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path fillRule="evenodd" d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" clipRule="evenodd" />
                            </svg>
                            <span className="font-medium">Mon Compte</span>
                          </span>
                          <span
                            onClick={(e) =>history.push("/wish-list")}
                            className="flex items-center space-x-3 py-3 px-6 hover:bg-yellow-50 cursor-pointer transition-colors"
                          >
                            <svg
                              className="w-5 h-5 text-red-500"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" />
                            </svg>
                            <span className="font-medium">Mes favoris</span>
                          </span>
                          <span
                            onClick={(e) => history.push("/user/setting")}
                            className="flex items-center space-x-3 py-3 px-6 hover:bg-yellow-50 cursor-pointer transition-colors"
                          >
                            <svg
                              className="w-5 h-5 text-blue-600"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path fillRule="evenodd" d="M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 00-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 00-2.282.819l-.922 1.597a1.875 1.875 0 00.432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 000 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 00-.432 2.385l.922 1.597a1.875 1.875 0 002.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 002.28-.819l.923-1.597a1.875 1.875 0 00-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 000-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 00-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 00-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 00-1.85-1.567h-1.843zM12 15.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z" clipRule="evenodd" />
                            </svg>
                            <span className="font-medium">Paramètre</span>
                          </span>
                          <span
                            onClick={(e) => logout()}
                            className="flex items-center space-x-3 py-3 px-6 text-red-600 hover:bg-red-50 cursor-pointer transition-colors border-t"
                          >
                            <svg
                              className="w-5 h-5"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path fillRule="evenodd" d="M7.5 3.75A1.5 1.5 0 006 5.25v13.5a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5V15a.75.75 0 011.5 0v3.75a3 3 0 01-3 3h-6a3 3 0 01-3-3V5.25a3 3 0 013-3h6a3 3 0 013 3V9A.75.75 0 0115 9V5.25a1.5 1.5 0 00-1.5-1.5h-6zm10.72 4.72a.75.75 0 011.06 0l3 3a.75.75 0 010 1.06l-3 3a.75.75 0 11-1.06-1.06l1.72-1.72H9a.75.75 0 010-1.5h10.94l-1.72-1.72a.75.75 0 010-1.06z" clipRule="evenodd" />
                            </svg>
                            <span className="font-medium">Déconnexion</span>
                          </span>
                        </li>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <li className="flex flex-col text-gray-700 w-52 shadow-lg bg-white rounded-lg overflow-hidden">
                          <span
                            onClick={(e) => history.push("/admin/dashboard")}
                            className="flex items-center space-x-3 py-3 px-6 hover:bg-yellow-50 cursor-pointer transition-colors"
                          >
                            <svg
                              className="w-5 h-5 text-blue-600"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path fillRule="evenodd" d="M3 6a3 3 0 013-3h2.25a3 3 0 013 3v2.25a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm9.75 0a3 3 0 013-3H18a3 3 0 013 3v2.25a3 3 0 01-3 3h-2.25a3 3 0 01-3-3V6zM3 15.75a3 3 0 013-3h2.25a3 3 0 013 3V18a3 3 0 01-3 3H6a3 3 0 01-3-3v-2.25zm9.75 0a3 3 0 013-3H18a3 3 0 013 3V18a3 3 0 01-3 3h-2.25a3 3 0 01-3-3v-2.25z" clipRule="evenodd" />
                            </svg>
                            <span className="font-medium">Admin Panel</span>
                          </span>
                          <span
                            onClick={(e) => logout()}
                            className="flex items-center space-x-3 py-3 px-6 text-red-600 hover:bg-red-50 cursor-pointer transition-colors border-t"
                          >
                            <svg
                              className="w-5 h-5"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path fillRule="evenodd" d="M7.5 3.75A1.5 1.5 0 006 5.25v13.5a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5V15a.75.75 0 011.5 0v3.75a3 3 0 01-3 3h-6a3 3 0 01-3-3V5.25a3 3 0 013-3h6a3 3 0 013 3V9A.75.75 0 0115 9V5.25a1.5 1.5 0 00-1.5-1.5h-6zm10.72 4.72a.75.75 0 011.06 0l3 3a.75.75 0 010 1.06l-3 3a.75.75 0 11-1.06-1.06l1.72-1.72H9a.75.75 0 010-1.5h10.94l-1.72-1.72a.75.75 0 010-1.06z" clipRule="evenodd" />
                            </svg>
                            <span className="font-medium">Déconnexion</span>
                          </span>
                        </li>
                      </Fragment>
                    )}
                  </div>
                </div>
              </Fragment>
            ) : (
              /* Login Modal Button */
              <div
                onClick={(e) => loginModalOpen()}
                className="cursor-pointer hover:bg-yellow-50 px-2 py-2 rounded-xl transition-all duration-200 group"
                title="Se connecter"
              >
                <svg
                  className="w-8 h-8 text-blue-800 group-hover:text-yellow-600 transition-colors"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path fillRule="evenodd" d="M7.5 3.75A1.5 1.5 0 006 5.25v13.5a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5V15a.75.75 0 011.5 0v3.75a3 3 0 01-3 3h-6a3 3 0 01-3-3V5.25a3 3 0 013-3h6a3 3 0 013 3V9A.75.75 0 0115 9V5.25a1.5 1.5 0 00-1.5-1.5h-6zm5.03 4.72a.75.75 0 010 1.06l-1.72 1.72h10.94a.75.75 0 010 1.5H10.81l1.72 1.72a.75.75 0 11-1.06 1.06l-3-3a.75.75 0 010-1.06l3-3a.75.75 0 011.06 0z" clipRule="evenodd" />
                </svg>
              </div>
            )}
            {/* Cart Modal Button */}
            <div
              onClick={(e) => history.push("/cart")}
              className="hover:bg-yellow-50 px-2 py-2 rounded-xl relative cursor-pointer transition-all duration-200 group"
              title="Panier"
            >
              <svg
                className="w-8 h-8 text-blue-800 group-hover:text-yellow-600 transition-colors"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M2.25 2.25a.75.75 0 000 1.5h1.386c.17 0 .318.114.362.278l2.558 9.592a3.752 3.752 0 00-2.806 3.63c0 .414.336.75.75.75h15.75a.75.75 0 000-1.5H5.378A2.25 2.25 0 017.5 15h11.218a.75.75 0 00.674-.421 60.358 60.358 0 002.96-7.228.75.75 0 00-.525-.965A60.864 60.864 0 005.68 4.509l-.232-.867A1.875 1.875 0 003.636 2.25H2.25zM3.75 20.25a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM16.5 20.25a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" />
              </svg>
              <span className="absolute top-0 right-0 -mt-1 -mr-1 bg-yellow-600 rounded-full w-5 h-5 flex items-center justify-center text-white text-xs font-bold shadow-lg">
                {getCartCount()}
              </span>
            </div>
          </div>
        </div>
        {/* Mobile Menu with overlay */}
        {data.navberHamburger && (
          <div
            className="fixed inset-0 bg-black/30 backdrop-blur-[1px] z-30 lg:hidden"
            onClick={() => closeMenu()}
            aria-hidden="true"
          />
        )}
        <div
            className={`${
              data.navberHamburger
                ? "fixed top-4 left-4 w-64 sm:w-72 bg-blue-200 shadow-2xl z-40 transform translate-x-0 transition-transform duration-300 ease-out lg:hidden rounded-2xl"
                : "fixed top-4 left-4 w-64 sm:w-72 bg-blue-200 shadow-2xl z-40 transform -translate-x-full transition-transform duration-300 ease-in lg:hidden rounded-2xl"
            }`}
        >
          {/* Menu Header */}
          

          {/* Menu Items */}
          <nav className="py-1">
            <div className="px-3 space-y-1">
              <a
                href="/" 
                onClick={() => navberToggleOpen()}
                className="flex items-center gap-3 px-3 py-3 text-gray-700 hover:bg-gradient-to-r hover:from-blue-50 hover:to-blue-100 hover:text-blue-700 rounded-lg transition-all duration-200 group"
              >
                <div className="w-9 h-9 bg-blue-200 rounded-lg flex items-center justify-center group-hover:bg-blue-200 group-hover:scale-105 transition-all duration-200 flex-shrink-0">
                  <svg className="w-5 h-5 text-blue-800" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
                    <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
                  </svg>
                </div>
                <div className="flex-1 min-w-0">
                  <span className="font-semibold text-sm block">Accueil</span>
                  <p className="text-xs text-gray-500 group-hover:text-blue-600 truncate">Page d'accueil</p>
                </div>
                <svg className="w-4 h-4 text-gray-400 group-hover:text-blue-600 group-hover:translate-x-0.5 transition-all duration-200 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>

              <a
                href="/#shop" 
                onClick={() => navberToggleOpen()}
                className="flex items-center gap-3 px-3 py-3 text-gray-700 hover:bg-gradient-to-r hover:from-yellow-50 hover:to-yellow-100 hover:text-yellow-700 rounded-lg transition-all duration-200 group"
              >
                <div className="w-9 h-9 bg-blue-200 rounded-lg flex items-center justify-center group-hover:bg-yellow-200 group-hover:scale-105 transition-all duration-200 flex-shrink-0">
                  <svg className="w-5 h-5 text-blue-800" fill="currentColor" viewBox="0 0 24 24">
                    <path fillRule="evenodd" d="M7.5 6v.75H5.513c-.96 0-1.764.724-1.865 1.679l-1.263 12A1.875 1.875 0 004.25 22.5h15.5a1.875 1.875 0 001.865-2.071l-1.263-12a1.875 1.875 0 00-1.865-1.679H16.5V6a4.5 4.5 0 10-9 0zM12 3a3 3 0 00-3 3v.75h6V6a3 3 0 00-3-3zm-3 8.25a3 3 0 106 0v-.75a.75.75 0 011.5 0v.75a4.5 4.5 0 11-9 0v-.75a.75.75 0 011.5 0v.75z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="flex-1 min-w-0">
                  <span className="font-semibold text-sm block">Nos Produits</span>
                  <p className="text-xs text-gray-500 group-hover:text-yellow-600 truncate">La boutique</p>
                </div>
                <svg className="w-4 h-4 text-gray-400 group-hover:text-yellow-600 group-hover:translate-x-0.5 transition-all duration-200 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>

              <button
                onClick={() => {
                  history.push("/contact-us");
                  window.scrollTo({ top: 0, behavior: "smooth" }); 
                  navberToggleOpen();
                }}
                className="flex items-center gap-3 px-3 py-3 text-gray-700 hover:bg-gradient-to-r hover:from-green-50 hover:to-green-100 hover:text-green-700 rounded-lg transition-all duration-200 group w-full text-left"
              >
                <div className="w-9 h-9 bg-blue-200 rounded-lg flex items-center justify-center group-hover:bg-green-200 group-hover:scale-105 transition-all duration-200 flex-shrink-0">
                  <svg className="w-5 h-5 text-blue-800" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                    <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                  </svg>
                </div>
                <div className="flex-1 min-w-0">
                  <span className="font-semibold text-sm block">Contacts</span>
                  <p className="text-xs text-gray-500 group-hover:text-green-600 truncate">Nous contacter</p>
                </div>
                <svg className="w-4 h-4 text-gray-400 group-hover:text-green-600 group-hover:translate-x-0.5 transition-all duration-200 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>

           
          </nav>
        </div>
        {/* Desktop fallback (old code for reference, can be removed if not needed) */}
        <div
            className="hidden show-on-desktop"
        >
        </div>
      </nav>
      {/* End Navber Section */}
    </Fragment>
  );
};

export default Navber;
